import BaseListPresenter from "../../../../../base/BaseListPresenter";

class ProfileListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    this.limit = 20;
    // this.where = {
    //   registrationStatus: "Approved",
    //   // is_Delete: { $exists: false },
    //   // is_Delete: true,
    // };
    this.where = {
      registrationStatus: "Approved",
      // is_Delete: { $exists: false },
      is_Delete: { $ne: true },
      // $or: [{ is_Delete: { $exists: false } }, { is_Delete: false }],
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  reset() {
    this.objects = [];
    this.count = 0;
    this.current = 1;
    this.view.setObjects([]);
    this.view.setSelected([]);
    this.view.setCount(0);
    this.view.setTotal(0);
  }

  async getObjects() {
    this.showProgress();
    this.reset();
    await this.countObjects();
    await this.findObjects();
    this.hideProgress();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },

      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    }
  }

  onSelectAffiliate(affiliateId) {
    this.filter = affiliateId ? { affiliate: { id: affiliateId } } : {};
    this.getObjects();
  }

  async exportCSV() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    this.view.setExporting(true);
    try {
      const allObjects = await this.findObjectUseCase.execute(collection, {
        where: query.where,
        include: this.include,
        sort: this.sort,
      });
      this.view.onExportReady(allObjects);
    } catch (error) {
      this.view.showError(error);
    } finally {
      this.view.setExporting(false);
    }
  }

  searchSubmit(search) {
    this.reset();
    this.search = search;
    this.getObjects();
  }

  async onClickActive(index) {
    try {
      const collectionName = this.view.getCollectionName();
      const object = this.objects[index];
      const newStatus = object.status === "Active" ? "Inactive" : "Active";
      const newObject = {
        id: object?.id,
        registrationStatus: "Approved",
        status: newStatus,
      };
      await this.upsertUseCase.execute(collectionName, newObject);
    } catch (error) {
      console.error(error);
    } finally {
      this.getObjects();
    }
  }

  // async onClickDelete(index, user) {
  //   try {
  //     const querySession = {
  //       where: {
  //         user: { id: user.id },
  //       },
  //       sort: { createdAt: -1 },
  //     };
  //     const collectionName = this.view.getCollectionName();
  //     const object = this.objects[index];
  //     const newObject = { id: object?.id, is_Delete: true };
  //     // console.log("newob", newObject);
  //     const sessions = await this.findObjectUseCase.execute(
  //       "sessions",
  //       querySession,
  //     );
  //     // console.log("sessions", sessions);
  //     await this.deleteObjectUseCase.execute("sessions", sessions[0]?.id);
  //     await this.upsertUseCase.execute(collectionName, newObject);
  //   } catch (error) {
  //     console.error(error);
  //   } finally {
  //     this.getObjects();
  //   }
  // }
  async onClickDelete(index, user) {
    try {
      const querySession = {
        where: { user: { id: user.id } },
        sort: { createdAt: -1 },
      };
      const collectionName = this.view.getCollectionName();
      const object = this.objects[index];
      const newObject = { id: object?.id, is_Delete: true };

      const sessions = await this.findObjectUseCase.execute(
        "sessions",
        querySession,
      );

      // if (sessions?.length) {
      //   await Promise.all(
      //     sessions.map((s) =>
      //       this.deleteObjectUseCase.execute("sessions", s.id),
      //     ),
      //   );
      // }

      if (sessions?.length) {
        await this.deleteObjectUseCase.execute("sessions", sessions[0].id);
      }

      await this.upsertUseCase.execute(collectionName, newObject);
    } catch (error) {
      console.error(error);
    } finally {
      this.getObjects();
    }
  }
}

export default ProfileListPresenter;
